<template>
  <div id="app">
    <homePages></homePages>
  </div>
</template>
<script>
  import homePages from './pages/homePages/index.vue'
  import { getUserInfoById } from './api/relationship'

  const REMOTE_PERMISSION_CHECK_INTERVAL = 60 * 60 * 1000

  export default {
    data() {
      return {
        remotePermissionCheckTimer: null,
        remotePermissionCheckPending: false,
      }
    },
    created() {
      this.fbiSF()
      this.getPhoneType()
    },
    mounted() {
      this.startRemotePermissionCheck()
    },
    beforeDestroy() {
      window.clearInterval(this.remotePermissionCheckTimer)
    },
    components: { homePages },
    methods: {
      startRemotePermissionCheck() {
        // 已登录用户打开页面时先检查一次，之后每小时检查一次。
        this.checkRemotePermission()
        this.remotePermissionCheckTimer = window.setInterval(
          this.checkRemotePermission,
          REMOTE_PERMISSION_CHECK_INTERVAL
        )
      },
      async checkRemotePermission() {
        if (localStorage.getItem('loginStatus') !== 'true' || this.remotePermissionCheckPending) {
          return
        }

        let appuser
        try {
          appuser = JSON.parse(localStorage.getItem('appuser'))
        } catch (error) {
          return
        }

        if (!appuser || !appuser.id) {
          return
        }

        this.remotePermissionCheckPending = true
        try {
          const res = await getUserInfoById(appuser.id)
          const userInfo = res.data && res.data.data
          if (userInfo && userInfo.loopRemote === '') {
            this.forceLogout()
          }
        } catch (error) {
          // 网络异常时保留登录状态，等待下一次检查，避免误退出。
        } finally {
          this.remotePermissionCheckPending = false
        }
      },
      forceLogout() {
        localStorage.removeItem('appuser')
        localStorage.removeItem('hospital')
        localStorage.removeItem('token')
        localStorage.setItem('loginStatus', false)
        this.$toast('远程功能已到期，请重新登录')
        if (this.$route.path !== '/login') {
          this.$router.push('/login')
        }
      },
      getPhoneType() {
        const u = navigator.userAgent
        const isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1 // android终端或者uc浏览器
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端

        if (isAndroid) {
          // Android
          localStorage.setItem('phoneType', 'Android')
        } else if (isiOS) {
          // ios
          localStorage.setItem('phoneType', 'ios')
        } else {
          localStorage.setItem('phoneType', 'web')
        }
      },
      fbiSF() {
        // 禁用双指放大
        document.documentElement.addEventListener(
          'touchstart',
          function (event) {
            if (event.touches.length > 1) {
              event.preventDefault()
            }
          },
          { passive: false }
        )

        // 禁用双击放大
        let lastTouchEnd = 0
        document.documentElement.addEventListener(
          'touchend',
          function (event) {
            const now = Date.now()
            if (now - lastTouchEnd <= 300) {
              event.preventDefault()
            }
            lastTouchEnd = now
          },
          { passive: false }
        )
      },
    },
  }
</script>
<style lang="less">
  #app {
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    background: #fff;
    text-align: center;
    color: #2c3e50;
    width: 100vw;
    font-size: 1rem;
    font-weight: 500;
  }
  @media screen and (-webkit-min-device-pixel-ratio: 0) {
    select,
    textarea,
    input {
      font-size: 16px;
    }
  }
  html {
    font-size: 12px;
    line-height: 12px;
  }
</style>
